import "../../../lib/store/createAppApi.js";
import "../../../lib/store/createAppAsyncThunk.js";
import "../../../lib/store/createAppSelector.js";
import { createAppSlice } from "../../../lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../lib/store/hooks/useAppDispatch.js";
import "../../../lib/store/hooks/useAppSelector.js";
import "../../../lib/store/hooks/useAppStore.js";
import { name } from "../config/name.js";
const initialState = {
  page: {
    ready: false,
    visited: []
  },
  filters: {
    ready: false
  }
};
const slice = createAppSlice({
  name,
  initialState,
  reducers: {
    reset: () => initialState,
    setPageReady: (state, action) => {
      state.page.ready = action.payload;
    },
    setFiltersReady: (state, action) => {
      state.filters.ready = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.page.current = action.payload;
    },
    addVisitedPage: (state, action) => {
      state.page.visited = Array.from(/* @__PURE__ */ new Set([...state.page.visited, action.payload]));
    }
  }
});
const { reducer, actions, reducerPath } = slice;
export {
  actions,
  reducer,
  reducerPath,
  slice
};
